import type { IconSvgObject } from './types';

const ChartCandleIcon: IconSvgObject = [
  ["path", { d: "M10 7.5V16.5C10 17.3284 9.32843 18 8.5 18H5.5C4.67157 18 4 17.3284 4 16.5V7.5C4 6.67157 4.67157 6 5.5 6H8.5C9.32843 6 10 6.67157 10 7.5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M20 12.5V16.5C20 17.3284 19.3284 18 18.5 18H15.5C14.6716 18 14 17.3284 14 16.5V12.5C14 11.6716 14.6716 11 15.5 11H18.5C19.3284 11 20 11.6716 20 12.5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M17 11V3M17 18V21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M7 6V3M7 18V21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default ChartCandleIcon;
